import { WAToolTip } from '../common/wa-tool-tip';
import { WALoader } from "../common/wa-loader.js";
import { AlertComponent } from "../common/wa-alert.js";
import { PageInteractor } from '../common/page-interactor'
import { GmailAuthenticator } from "../authenticators/gmail.authenticator.js";
import { FaceBookAuthenticator } from "../authenticators/facebook.authenticator.js";
import { scrollTo, makeElement, getMetaTagContent, getElement, trans } from "../common/helpers.js";

document.addEventListener('waConfigurationsLoaded', () => {
    const refCodeEl = getElement("#referral");
    const refCode = refCodeEl && referral.value !== "" ? referral.value : null;

    try {
        new WAToolTip(
            "#claim_account_tooltip",
            trans('claimAccount.tooltip'),
            true
        );
    } catch (e) {
        console.log(e);
    }
    try {
        if (registerErrors) {
            const pageInteractor = new PageInteractor();
            pageInteractor.forSection('expand');
            pageInteractor.simulate('click', () => {
                scrollTo(`[data-wa-component="alert"]`)
            });
        }
    } catch (e) {

    }
    try {
        let alertComponent = null;
        document.addEventListener('waGAuth', (ev) => {
            const auth = ev.detail;
            if (auth.error) {
                (new WALoader()).hide();
                if (alertComponent === null) {
                    alertComponent = new AlertComponent({
                        classes: ['col-centered', 'create-account-alert', 'alert-holder', 'visible']
                    });
                }
                alertComponent.text = "Unable to sign in with Google. Please try again later or use a different method to sign in.";
                alertComponent.render();
                return
            }
            const gLoginForm = makeElement(
                `<form method='POST' action='/google-login'>
                        <input type='hidden' name='_token' value="${getMetaTagContent('csrf-token')}">
                        <input type='hidden' name='oauth_id' value="${auth.authToken}">
                        <input type='hidden' name='userData[email]' value="${auth.email || ''}">
                        <input type='hidden' name='userData[firstName]' value="${auth.firstName || ''}">
                        <input type='hidden' name='userData[lastName]' value="${auth.lastName || ''}">
                    </form>`
            );
            document.body.append(gLoginForm);
            gLoginForm.submit();
        });

        const gmailAuth = new GmailAuthenticator(window.google_login_client_id);

        $('#gmailRegister').on('click', (e) => {
            gmailAuth.extractUserInformation()
        });
    } catch (error) {
        // Log errors if needed
        console.log(error)
    }
    try {
        if (window.facebook_login_client_id && window.facebook_login_client_id !== '') {
            const fbInstance = new FaceBookAuthenticator(window['facebook_login_client_id'])
            document.getElementById('fbRegister').addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation();
                (new WALoader()).show();
                fbInstance.login().then(userData => {
                    const fbLoginForm = makeElement(
                        `<form method='POST' action='/facebook-login'>
                                <input type='hidden' name='_token' value="${getMetaTagContent('csrf-token')}">
                                <input type='hidden' name='oauth_id' value="${userData.accessToken}">
                            </form>`
                    );
                    if (refCode) fbLoginForm.appendChild(makeElement(`<input type='hidden' name='referral' value="${refCode}">`))
                    document.body.append(fbLoginForm);
                    fbLoginForm.submit();
                }).catch((e) => {
                    (new WALoader()).hide();
                    if (alertComponent === null) {
                        alertComponent = new AlertComponent({
                            classes: ['col-centered', 'create-account-alert', 'alert-holder', 'visible']
                        });
                    }

                    alertComponent.text = trans('authentication.signIn.facebook.error');
                    alertComponent.render();
                })
            })
        }
    } catch (error) {

    }
});